import styled from 'styled-components';
import Colors from '../../styles/colors';

export const PinInputWrapper = styled.div<{ isError: boolean }>`
  background-color: rgb(232, 232, 232);
  border: 2px solid !important;
  border-color: ${({ isError }) => (isError ? Colors.red : 'rgb(136,136,136)')} !important;
  border-radius: 6px;
  display: inline-block;
  position: relative;
  &:focus-within {
    border-color: ${Colors.greenishTeal} !important;
  }
  &::after {
    content: '–';
    display: block;
    position: absolute;
    width: 20px;
    top: 0;
    left: 50%;
    margin-left: -10px;
    line-height: 50px;
    font-size: 20px;
    color: #000;
    text-align: center;
  }
  & input {
    text-transform: uppercase;
    text-align: center;
    width: 40px;
    height: 50px;
    margin: 0;
    background-color: white !important;
    border: none !important;
    font-size: 20px;
    font-weight: 500;
    color: #000;
    box-sizing: content-box;
  }
  & input:first-child {
    border-radius: 6px 0 0 6px;
  }
  & input:last-child {
    border-radius: 0 6px 6px 0;
  }
  & input:not(:last-child) {
    border-right: 1px solid #d2d2d2 !important;
  }
  & input:nth-child(4) {
    margin-right: 31px !important;

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      margin-right: 40px !important;
    }
  }
`;
